export const BRANCH_INITIAL_STATE={
    branch_name: '',
    contact_number: '',
    contact_person: '',
    email: '',
    date_of_est: null,
    address: '',
    locality: '',
    city: '',
    state: null,
    country: 'india',
    pincode: '',
    landmark: '',
    status:true
  }